/**
 * Created by intellicar-rinas on 8/8/17.
 */
const actions = {
    "AUTH_SUCCESS": "AUTH_SUCCESS",
    "AUTH_FAILURE": "AUTH_FAILURE",
    "VEHICLE_MAP_UPDATED": "VEHICLE_MAP_UPDATED",
    "STATS_UPDATED": "STATS_UPDATED",
    "TOGGLE_ONROAD": "TOGGLE_ONROAD",
    "TOGGLE_OFFROAD": "TOGGLE_OFFROAD",
    "TOGGLE_REPORT_WINDOW": "TOGGLE_REPORT_WINDOW",
    "TOGGLE_REPORT_WINDOW_TAB": "TOGGLE_REPORT_WINDOW_TAB",
    "TOGGLE_RTGPS": "TOGGLE_RTGPS",
    "TOGGLE_STATS_FILTER": "",
    "SINGLE_SEARCH": "SINGLE_SEARCH",
    "GRAPH_ZOOMED": "GRAPH_ZOOMED",
    "GRAPH_BRUSHED": "GRAPH_BRUSHED",
    "GEOFENCE_MAP_UPDATED": "GEOFENCE_MAP_UPDATED",
    "GOT_ALL_BUCKETS": "GOT_ALL_BUCKETS",
    "GEOFENCE_FILTER_UPDATED": "GEOFENCE_FILTER_UPDATED",
    "OVERLAY_FILTER_UPDATED": "OVERLAY_FILTER_UPDATED",
    "GRAPHSET_STATE_CHANGED": "GRAPHSET_STATE_CHANGED",
    "ADD_INTOAST": "ADD_INTOAST",
    "UPDATE_INTOAST_LIST": "UPDATE_INTOAST_LIST",
    "SELECTED_VEHICLE_UPDATED": "SELECTED_VEHICLE_UPDATED",
    "USERINFO_UPDATED": "USERINFO_UPDATED",
    "RIGHT_PANE_VIEW_CHANGED": "RIGHT_PANE_VIEW_CHANGED",
    "RIGHT_PANE_TOGGLED": "RIGHT_PANE_TOGGLED",
    "GROUP_TREE_UPDATE": "GROUP_TREE_UPDATE",
    "TOGGLE_LEFT_TREE": "TOGGLE_LEFT_TREE",
    "TOGGLE_RECENT_DEVICES": "TOGGLE_RECENT_DEVICES",
    "TOGGLE_TABLE_VIEW": "TOGGLE_TABLE_VIEW",
    "TOGGLE_AMPLUSIMMOB":"TOGGLE_AMPLUSIMMOB",
    "CALCULATE_ALLOWED_VEHICLES": "CALCULATE_ALLOWED_VEHICLES",
    "TOGGLE_FREEZ_MAP": "TOGGLE_FREEZ_MAP",
    "MULTI_SEARCH_CONDTIONS": "MULTI_SEARCH_CONDTIONS",
    "SET_DGEOFENCE_MODE": "SET_DGEOFENCE_MODE",
    "UPDATE_DGEOFENCE": "UPDATE_DGEOFENCE",
    'SETTINGS_PANE_TOGGLED': 'SETTINGS_PANE_TOGGLED',
    'SETTINGS_PANE_TAB_CHANGED': 'SETTINGS_PANE_TAB_CHANGED',
    'TOGGLE_ALARM': 'TOGGLE_ALARM',
    'DTC_TOGGLED' :'DTC_TOGGLED',
    'DTC_PANE_TAB_CHANGED': 'DTC_PANE_TAB_CHANGED',
    'SAVE_EV_REPORT': 'SAVE_EV_REPORT',
    'SAVE_EV_DASHBOARD_DATA': 'SAVE_EV_DASHBOARD_DATA',
    'SEARCH_RESULT_UPDATED': 'SEARCH_RESULT_UPDATED',
    'SOC_SORTED' : 'SOC_SORTED',
    'SELECTED_VEHICLE_ID' : 'SELECTED_VEHICLE_ID',
    'LOCK_BUTTON' : 'LOCK_BUTTON',
    'TOGGLE_LASTLOC' : 'TOGGLE_LASTLOC',
    'TOGGLE_MUTE' : 'TOGGLE_MUTE',
    'TOGGLE_BULK_IMMOB':'TOGGLE_BULK_IMMOB',
    'ADD_INTOAST_LOCATION': 'ADD_INTOAST_LOCATION',
    'UPDATE_INTOAST_LOCATION_LIST':'UPDATE_INTOAST_LOCATION_LIST'

};

export default actions;